/**
 * Renders a few real strings in the selected language, so switching EN/ES is
 * visibly wired end to end. Scaffolding; the operator screens replace it.
 */

import { useI18n } from '../lib/i18n.tsx';
import { StatusRow } from './StatusRow.tsx';

export function TranslationCheck() {
  const { t, plural } = useI18n();

  return (
    <dl className="flex flex-col gap-3">
      <StatusRow term={t('osha_tag_out')}>
        <span className="text-ink-secondary">{t('checklist_finish')}</span>
      </StatusRow>
      <StatusRow term={t('pin_title')}>
        <span className="text-ink-secondary">{plural('queued', 3)}</span>
      </StatusRow>
      <StatusRow term={t('truck_heading', { assetNumber: 'FL-12' })}>
        <span className="text-ink-secondary">{plural('queued', 1)}</span>
      </StatusRow>
    </dl>
  );
}
